import { createRouter, createWebHistory } from 'vue-router'
import { observerGuard } from './observerGuard'
import { loadLocales } from '@/utils/i18n.utils'
import { ensureObserverLocaleReady } from '@/pages/observer/services/observerLocale'

const ThirdPartyObserverLayout = () =>
  import('@/layouts/observer/ThirdPartyObserverLayout.vue')

const ObserverMessagesPage = () =>
  import('@/pages/observer/messages/ObserverMessagesPage.vue')
const ObserverCallingPage = () =>
  import('@/pages/observer/calling/ObserverCallingPage.vue')
const ObserverCalendarPage = () =>
  import('@/pages/observer/calendar/ObserverCalendarPage.vue')
const ObserverPaymentsPage = () =>
  import('@/pages/observer/payments/ObserverPaymentsPage.vue')
const ObserverSessionEnded = () =>
  import('@/pages/observer/shared/ObserverSessionEnded.vue')
const ObserverRestrictedContent = () =>
  import('@/pages/observer/shared/ObserverRestrictedContent.vue')

const router = createRouter({
  history: createWebHistory('/observer'),
  routes: [
    {
      path: '/',
      component: ThirdPartyObserverLayout,
      beforeEnter: observerGuard,
      children: [
        { path: '', redirect: { name: 'observer-messages' } },
        {
          path: 'messages',
          name: 'observer-messages',
          component: ObserverMessagesPage,
          meta: { requiresProfessionalAuth: true, section: 'observer' },
          beforeEnter: async () => await loadLocales('messages')
        },
        {
          path: 'calling',
          name: 'observer-calling',
          component: ObserverCallingPage,
          meta: { requiresProfessionalAuth: true, section: 'observer' },
          beforeEnter: async () => await loadLocales('calling')
        },
        {
          path: 'calendar/:startDate?',
          name: 'observer-calendar',
          component: ObserverCalendarPage,
          meta: { requiresProfessionalAuth: true, section: 'observer' },
          beforeEnter: async () => await loadLocales('calendar')
        },
        {
          path: 'payments',
          name: 'observer-payments',
          component: ObserverPaymentsPage,
          meta: { requiresProfessionalAuth: true, section: 'observer' },
          beforeEnter: async () => await loadLocales('payments')
        }
      ]
    },
    {
      path: '/session-ended',
      name: 'observer-session-ended',
      component: ObserverSessionEnded,
      meta: { requiresProfessionalAuth: false }
    },
    {
      path: '/restricted',
      name: 'observer-restricted',
      component: ObserverRestrictedContent,
      meta: { requiresProfessionalAuth: false }
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: { name: 'observer-session-ended', query: { reason: 'error' } }
    }
  ]
})

// Ensures locale is resolved before any route loads its locale namespace.
router.beforeEach(async () => {
  await ensureObserverLocaleReady()
})

export default router
